import React from 'react';
// This section has been merged into InvestorsSection.tsx to reduce the number of dark sections.
// Exporting a null component to prevent breaking any lingering imports.
export function ArchitectureSection() {
  return null;
}